import { createAction, props } from '@ngrx/store';
import { ProjectTemplate } from './models/project-template.model';

export const ProjectTemplatesLoadedAction = createAction(
  '[Project Template Effects] Templates Loaded',
  props<{ templates: ProjectTemplate[] }>(),
);

export const ProjectTemplatesErroredAction = createAction(
  '[Project Template Effects] Templates Errored',
);

export const ProjectTemplatesErrorTimedOutAction = createAction(
  '[Nav Bar] Project Templates Error Timed Out',
);

export const ProjectTemplatesPermissionDeniedAction = createAction(
  '[Project Template Effects] Templates Permission Denied',
);
